import {
  GET_DEPARTMENT_ERR,
  GET_DEPARTMENT_OK,
  DELETE_DEPARTMENT_ERR,
  DELETE_DEPARTMENT_OK,
  CREATE_DEPARTMENT_ERR,
  UPD_DEPARTMENT_ERR,
  UPD_DEPARTMENT_OK,
  GET_DEPARTMENT_LOOKUP_OK,
  GET_DEPARTMENT_LOOKUP_ERR,
} from "./department.action";

const InitState = {
  error: null,
  content: null,
};

export default function DepartmentAdmReducer(state = InitState, action) {
  switch (action.type) {
    case GET_DEPARTMENT_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_DEPARTMENT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    case DELETE_DEPARTMENT_OK: {
      const id = action.payload.Id;
      return {
        ...state,
        error: null,
        content: {
          items: state.content.items.filter((item) => item.id !== id),
        },
      };
    }
    case DELETE_DEPARTMENT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case CREATE_DEPARTMENT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case UPD_DEPARTMENT_OK: {
      const itemParameter = action.payload;
      return {
        ...state,
        content: {
          items: state.content.items.map((item) =>
            item.id === itemParameter.id
              ? // transform the one with a matching id
                {
                  ...item,
                  name: itemParameter.name,
                  order: itemParameter.order,
                  isActive: itemParameter.isActive,
                }
              : // otherwise return original todo
                item
          ),
        },
      };
    }
    case UPD_DEPARTMENT_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    default:
      return state;
  }
}

export function DepartmentLookupAdmReducer(state = InitState, action) {
  switch (action.type) {
    case GET_DEPARTMENT_LOOKUP_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_DEPARTMENT_LOOKUP_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
